module.exports = __webpack_public_path__ + "app-static/img/01.540ffb48.jpg";